const getUniqueFeatureFlags = (featureFlags) => [...new Set(featureFlags)];

export default getUniqueFeatureFlags;
